import { memo } from "react";
import Banners from "components/Banners";
import { styled } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";

const PageRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100dvh",
  width: "100%",
});

const PageContent = styled("div")({
  display: "flex",
  flex: 1,
  minHeight: 0,
  width: "100%",
});

interface PageBaselineProps {
  children?: React.ReactNode;
}

function PageBaseline(props: PageBaselineProps) {
  return (
    <PageRoot>
      <CssBaseline />
      <Banners />
      <PageContent>{props.children}</PageContent>
    </PageRoot>
  );
}

export default memo(PageBaseline);
